import { render, staticRenderFns } from "./settings-account-general.vue?vue&type=template&id=002aa34c&scoped=true&"
import script from "./settings-account-general.vue?vue&type=script&lang=js&"
export * from "./settings-account-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002aa34c",
  null
  
)

export default component.exports